export function getStage(): string {
  const envStage: HTMLElement = document.getElementById("env-stage") as HTMLElement;
  return envStage.innerHTML.toLocaleLowerCase().trim()
}
